<template>
  <form @submit.prevent="onSubmit">
    <div v-if="hasSubject">
      <label class="text-sm font-bold uppercase text-gray-600" for="body">Emne</label>
      <div class="mt-2">
        <input class="w-full bg-white focus:bg-white" :class="{ 'bg-gray-100 text-gray-500': isSending }" type="text" id="subject" ref="subject" v-model="subject" :disabled="isSending">
      </div>
    </div>
    <div class="mt-6">
      <label class="text-sm font-bold uppercase text-gray-600" for="body">Melding</label>
      <div class="mt-2">
        <textarea class="w-full h-64 bg-white focus:bg-white" :class="{ 'bg-gray-100 text-gray-500': isSending }" id="body" ref="body" v-model="body" :disabled="isSending">></textarea>
      </div>
    </div>

    <div class="mt-6" v-if="userSelectVisible && users.length > 0">
      <label class="text-sm font-bold uppercase text-gray-600" for="body">Mottakere</label>
      <div class=" mt-2">
        <button class="flex items-center py-1 px-2 rounded border-2 border-transparent focus:outline-none focus:border-red-500" v-for="(user, index) in users" :key="index" @click.prevent="toggle(user)">
          <font-awesome-icon :icon="['far', user.selected ? 'check-square' : 'square']" :class="{ 'text-red-500': user.selected }" />
          <div class="ml-2">{{ user.chain }} ved {{ user.name }}</div>
        </button>
      </div>
    </div>

    <div class="flex items-start justify-between mt-6">
      <button type="submit" class="btn btn-primary" :class="{ 'p-2': isSending }" :disabled="!canSubmit">
        <div class="flex items-center">
          <font-awesome-icon :icon="['far', isSending ? 'spinner' : 'envelope']" :spin="isSending" />
          <div class="ml-3" v-show="!isSending">Send</div>
        </div>
      </button>
      <div class="ml-2 text-sm px-3 py-1 bg-red-200 text-red-700" v-if="!textOk">Forekomster av xx må erstattes med riktig innhold.</div>
    </div>
  </form>
</template>

<script>
import _ from 'lodash'
import api from '@/api'
import * as emailTemplateTypes from '@/store/emailTemplateTypes'
export default {
  name: 'message-form',
  props: {
    'templateId': {
      type: Number,
      required: true
    },
    'hasSubject': {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      users: [],
      errors: [],
      subject: '',
      body: '',
      isSending: false,
      userSelectVisible: false
    }
  },
  methods: {
    async onSubmit () {
      this.isSending = true
      await api.af.createEmailMessage({
        emailTemplateId: this.templateId,
        userIds: this.selectedUserIds,
        subject: this.subject,
        body: this.body
      })
      this.isSending = false

      this.$emit('submitted', {
        subject: this.subject,
        body: this.body
      })
    },
    toggle (user) {
      this.$set(user, 'selected', user.selected ? false : true)
    }
  },
  computed: {
    textOk () {
      return this.body.toLowerCase().indexOf('xx') === -1
    },
    canSubmit () {
      const usersOk = !this.userSelectVisible || (this.userSelectVisible && this.selectedUserIds.length > 0)
      return !this.isSending && usersOk && this.textOk
    },
    selectedUsers () {
      return _.filter(this.users, u => u.selected)
    },
    selectedUserIds () {
      return _.map(this.selectedUsers, u => u.userId)
    }
  },
  async mounted () {

    const template = await api.af.getEmailTemplate(this.templateId)

    this.subject = template.subject
    this.body = template.body

    // This particular email-template requires the user to
    // select which chain contacts that will receive the reminder.
    if (template.emailTemplateType === emailTemplateTypes.ChainContact_Reminder) {
      this.users = await api.af.getChainContactUsers()
      this.userSelectVisible = true
    }

  }
}
</script>